export const types = {
    SET_GET_ROLE: '[ROLE] SET GET ROLE',
    SET_GET_ROLE_BY_ID: '[ROLE] SET GET ROLE BY ID'
}